var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cs",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.342,
    height: 58.731,
    viewBox: "0 0 51.342 58.731",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M72.242,20.09a20.09,20.09,0,0,0-40.181,0c-2.868.357-5.581,2.232-5.581,6.585V37.167c0,4.911,3.438,6.7,6.7,6.7h3.237a1.116,1.116,0,0,0,1.116-1.116V21.14a1.116,1.116,0,0,0-1.116-1.116H34.293a17.858,17.858,0,1,1,35.716,0H67.889a1.116,1.116,0,0,0-1.116,1.116V42.714a1.116,1.116,0,0,0,1.116,1.116h2.121c-.313,7.668-4,9.465-11.351,9.788v-.748a2.232,2.232,0,0,0-2.232-2.232h-7.02a2.232,2.232,0,0,0-2.232,2.232V56.5a2.232,2.232,0,0,0,2.232,2.232h7.043A2.232,2.232,0,0,0,58.68,56.5v-.647c7.076-.324,13.193-1.786,13.561-12.088,2.868-.357,5.581-2.232,5.581-6.585V26.687C77.822,22.312,75.121,20.448,72.242,20.09ZM35.3,22.178V41.6H33.121c-1.652,0-4.465-.58-4.465-4.465V26.642c0-3.851,2.779-4.465,4.465-4.465ZM56.448,54.813v1.7H49.405V52.882h7.043ZM75.59,37.167c0,3.851-2.779,4.465-4.465,4.465H69V22.256h2.176c1.652,0,4.465.58,4.465,4.465Z",
    transform: "translate(-26.48)",
    fill: "#111a51"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCs);
export default __webpack_public_path__ + "static/media/cs.2342d3e28baa5b7d4cac218d88feb8e9.svg";
export { ForwardRef as ReactComponent };